import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import Button from '../../../../../incase-domain/components/button/Button';
import {updateSelectedSlideAction} from '../../../../../store/actions/slide';
import {selectedPresentationSelector} from '../../../../../store/selectors/presentation.selectors';
import {selectedSlideIndexSelector} from '../../../../../store/selectors/slide.selectors';

function MobileViewFooter(): JSX.Element {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const selectedSlideIndex = useSelector(selectedSlideIndexSelector);
    const selectedPresentation = useSelector(selectedPresentationSelector);
    const slides = selectedPresentation.slides || [];

    const isFirstSlide = selectedSlideIndex === 0;
    const isLastSlide = selectedSlideIndex === slides.length - 1;

    const handlePreviousSlide = (): void => {
        if (isFirstSlide) return;
        const prevIndex = selectedSlideIndex - 1;
        dispatch(updateSelectedSlideAction(slides[prevIndex], prevIndex, false));
    };

    const handleNextSlide = (): void => {
        if (!isLastSlide) return;
        const nextIndex = selectedSlideIndex + 1;
        dispatch(updateSelectedSlideAction(slides[nextIndex], nextIndex, false));
    };

    return (
        <div className="p-presEdit__mobileFooter">
            <Button
                leading="solar:alt-arrow-left-linear"
                dynamicSize
                size="xl"
                variant="ghost"
                disabled={isFirstSlide}
                onClick={handlePreviousSlide}
            />
            <div className="p-presEdit__mobileFooter_center">
                <Button size="lg" dynamicSize fullWidth disabled={isLastSlide} onClick={handleNextSlide}>
                    <div>{t('footer.nextSlide')}</div>
                </Button>
            </div>
            <Button
                leading="solar:alt-arrow-right-linear"
                dynamicSize
                size="xl"
                variant="ghost"
                disabled={isLastSlide}
                onClick={handleNextSlide}
            />
        </div>
    );
}

export default MobileViewFooter;
